import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface LoadState {
  progress: number;
  resource: {
    [id: string]: { progress: number };
  };
  updateProgress: (id: string, progress: number) => void;
}

export const useLoadStore = create<LoadState>()(
  devtools(
    // persist(
    set => ({
      progress: 0,
      resource: {},
      updateProgress: (id: string, resPorgress: number) => {
        // console.log('updateProgress', id, resPorgress);
        set(state => {
          const resource = state.resource;
          let progress = state.progress;
          if (resource[id]) {
            resource[id].progress = resPorgress;
          } else {
            resource[id] = { progress: resPorgress };
          }
          let sum = 0,
            totalP = 0;
          const entries = Object.entries(resource);
          entries.forEach(([key, value]) => {
            sum += 1;
            totalP += value.progress;
          });
          progress = totalP / sum;
          // console.log('progress', progress);
          // console.log('resource', resource);
          return {
            progress,
            resource,
          };
        });
      },
    }),
    {
      name: 'load-storage',
    }
  )
  // )
);
